import * as S from "../Style/Page/Fork.style.js";
const HatPageTopLine = (props) => {
  return (
    <S.PageTopLine>
      <div></div>
      <div className="page-top-line-title">
        {" "}
        <div class="kor">{props.titleko}</div>
        <div class="eng">{props.titleeng}</div>
      </div>
      <div></div>
    </S.PageTopLine>
  );
};

export default HatPageTopLine;
